import React from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";
import PropTypes from "prop-types";

const VideoPlayer = ({ className, url, ...props }) => {
  return (
    <div className={`${className}`}>
      <ReactPlayer
        className="react-player"
        url={url}
        width="100%"
        height="100%"
        controls
        {...props}
      />
    </div>
  );
};

VideoPlayer.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string.isRequired
};

VideoPlayer.defaultProps = {
  className: ""
};

export default styled(VideoPlayer)`
  position: relative;
  height: ${props => props.height};
  padding-top: ${props => props.paddingTop || "56.25%"};
  margin-bottom: ${props => props.marginBottom || props.theme.spacing.xl3};
  margin-top: ${props => props.marginTop || props.theme.spacing.xl1};

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;
